import { MNSproCloudApi } from '..';
import {
  SchoolLinkCreateRequest,
  SchoolLinkResponse,
  SchoolLinkUpdateRequest,
} from '../api/v2';

export class SchoolLinksService {
  static async getFavorites(authToken: string, organizationId: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SchoolLinksApiFactory(config);

    const result = await api
      .getList(organizationId)
      .then(l => api.getFavorites(l.data?.id ?? '', organizationId));

    return result.data;
  }

  static async getAll(authToken: string, organizationId: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SchoolLinksApiFactory(config);

    const result = await api
      .getList(organizationId)
      .then(l => api.getAll(l.data?.id ?? '', organizationId));

    return result.data;
  }

  static async creatLink(
    authToken: string,
    organizationId: string,
    schoolLinkCreateRequest: SchoolLinkCreateRequest,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SchoolLinksApiFactory(config);

    const result = await api.getList(organizationId).then(l =>
      api.create({
        ...schoolLinkCreateRequest,
        organizationId: organizationId,
        listId: l.data?.id,
      }),
    );

    return result.data;
  }

  static async updateLink(
    authToken: string,
    organizationId: string,
    schoolLinkUpdateRequest: SchoolLinkUpdateRequest,
  ): Promise<SchoolLinkResponse> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SchoolLinksApiFactory(config);

    const listResponse = await api.getList(organizationId);
    const list = listResponse.data;

    const udpateResponse = await api.update({
      ...schoolLinkUpdateRequest,
      listId: list.id,
    });

    return udpateResponse.data;
  }

  static async deleteLink(
    authToken: string,
    organizationId: string,
    linkId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SchoolLinksApiFactory(config);

    const result = await api
      .getList(organizationId)
      .then(l => api._delete(linkId, l.data?.id ?? '', organizationId));

    return result.data;
  }

  static async getFavicon(
    authToken: string,
    organizationId: string,
    url: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SchoolLinksApiFactory(config);

    const result = await api.getFavicon(organizationId, url);

    return result.data;
  }
}
